import React from 'react';
import { Row } from 'antd';
import SetTitle from '../../utils/DynamicTitleHelper';
import classes from './AssuranceWizardLayout.module.less';
import Header from '../common/Header';
import Footer from '../common/Footer';
import { useSelector } from 'react-redux';
import { userDisplayNameSelector } from '../../containers/login/store/selectors';

type Props = {
  children: JSX.Element;
  header?: string;
  title?: string /** @description set title of the browser window */;
};

const AssuranceWizardLayout: React.FC<Props> = ({
  children,
  header,
  title,
}) => {
  SetTitle(title || 'Assurance Wizard');
  const userDisplayName = useSelector(userDisplayNameSelector) || '';

  return (
    <div className={classes.setupArea}>
      <Header data-testid="page-header" title={userDisplayName} />
      <div className={classes.gridContainer}>
        <div className={classes.gridItem}>
          {header && (
            <Row>
              <div className={classes.header}>{header}</div>
            </Row>
          )}
          {children}
        </div>
      </div>
      <Footer data-testid="page-footer" />
    </div>
  );
};

export default AssuranceWizardLayout;
